import React, { useState } from 'react';
import { api } from '@/lib/api';
import { PageHeader } from '@/components/ui-kit/PageBits';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { toast } from 'sonner';
import { Upload } from 'lucide-react';

export default function PGNImport() {
  const [pgn, setPgn] = useState('');
  const [analysis, setAnalysis] = useState(null);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.post('/games', { pgn });
      toast.success(`Partida importada: ${data.white_player} vs ${data.black_player}`);
      setPgn('');
    } catch { toast.error('PGN inválido'); }
    finally { setSaving(false); }
  };

  const analyze = async () => {
    try {
      const { data } = await api.post('/games/analyze', { pgn });
      setAnalysis(data);
    } catch { toast.error('No se pudo analizar'); }
  };

  return (
    <div className="p-8 max-w-5xl mx-auto">
      <PageHeader title="Importar PGN" subtitle="Sube partidas para la base de datos"/>
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="rounded-2xl bg-white border border-slate-200 p-6">
          <Textarea data-testid="pgn-textarea" value={pgn} onChange={(e)=>setPgn(e.target.value)} rows={14}
            placeholder='[Event "..."]&#10;[White "..."]&#10;[Black "..."]&#10;1. e4 e5 2. Nf3 Nc6 …'
            className="font-mono text-xs"/>
          <div className="mt-3 flex gap-2">
            <Button data-testid="pgn-save-btn" onClick={save} disabled={!pgn || saving} className="rounded-full bg-blue-600 hover:bg-blue-700">
              <Upload className="w-4 h-4 mr-1"/> Guardar en la base
            </Button>
            <Button data-testid="pgn-analyze-btn" onClick={analyze} disabled={!pgn} variant="outline" className="rounded-full">Analizar</Button>
          </div>
        </div>
        <div className="rounded-2xl bg-white border border-slate-200 p-6">
          <div className="font-display font-bold text-xl mb-3">Resumen</div>
          {!analysis ? <div className="text-sm text-slate-500">Pega un PGN y pulsa Analizar.</div> : (
            <div className="space-y-2 font-mono text-sm">
              <div>Total jugadas: <b>{analysis.total_moves}</b></div>
              <div>Blancas: <b>{analysis.white_moves}</b></div>
              <div>Negras: <b>{analysis.black_moves}</b></div>
              <div>Resultado: <b>{analysis.result}</b></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
